export const TYPEWRITER_EXAMPLES = [
  "tiktok.com",
  "shopify.com",
  "airbnb.com",
  "instagram.com",
  "nike.com",
  "amazon.com",
] as const;

export const TICKER_FEED = [
  { flag: "🇺🇸", host: "shopify.com", ms: 38 },
  { flag: "🇩🇪", host: "kayak.de", ms: 27 },
  { flag: "🇬🇧", host: "asos.co.uk", ms: 31 },
  { flag: "🇯🇵", host: "rakuten.co.jp", ms: 86 },
  { flag: "🇫🇷", host: "leboncoin.fr", ms: 24 },
  { flag: "🇧🇷", host: "mercadolivre.com.br", ms: 71 },
  { flag: "🇳🇱", host: "bol.com", ms: 19 },
  { flag: "🇸🇬", host: "lazada.sg", ms: 49 },
] as const;
